/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespPromoModulePrimary_componentModule = {
    readonly messages: {
        readonly title: string | null;
        readonly items: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly linkData: {
                readonly path: string | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModulePromoItem_promotion">;
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespPromoModulePrimary_componentModule";
};
export type HpRespPromoModulePrimary_componentModule$data = HpRespPromoModulePrimary_componentModule;
export type HpRespPromoModulePrimary_componentModule$key = {
    readonly " $data"?: HpRespPromoModulePrimary_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModulePrimary_componentModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespPromoModulePrimary_componentModule",
  "type": "PromoModule",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userType",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "messages",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "PromoModuleMessages",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": null,
          "concreteType": "PromoItem",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cmsId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "linkData",
              "storageKey": null,
              "args": null,
              "concreteType": "LinkData",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "path",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "HpRespPromoModulePromoItem_promotion",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '9a4d0b8bccb537e6e66f16db6b4cfc6d';
export default node;
